window.load = setTaggage();

$(document).ajaxComplete(function (event, xhr, settings) {
	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function (str, word) {
			return str.lastIndexOf(word, 0) === 0;
		}
	}
	if (settings.url == '/ListeResultats/FiltreListeResultats' || settings.url == '/ListeResultats/TrierListeResultats' || settings.url == '/ListeResultats/CalculFiltreListeResultats' || settings.url == '/ListeResultats/ListeVoyages') {
		setTaggage();
	}
});